<template>
  <div class="fileInfo-box">
    <div class="title"> <h3>文件信息</h3> </div>
      <el-form label-width="125px">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="'文件:'">{{insideData.video.name}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'格式:'">{{insideData.video.videoType}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="ID：">{{insideData.video.id}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="大小：">{{insideData.video.videoSize && (insideData.video.videoSize/1024/1024).toFixed(2)}}M</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上传路径：">{{(insideData.video && insideData.video.videoPath ? insideData.video.videoPath.substring(insideData.video.videoPath.lastIndexOf('/') - 11) : '')}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="封面图：">
              <el-image :src="isAudit=='isAudit'?insideData.video.videoImgPaths[0].imgPath:insideData.imgPath" style="height: 32px;">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="图片大小：">{{insideData.video.videoImgPaths[0].size}}K</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建用户：">{{insideData.video.createBy}}</el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="更新用户：">{{insideData.video.updateBy}}</el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="创建时间：">{{insideData.video.createTime|timeFormat}}</el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="更新时间：">{{insideData.video.updateTime|timeFormat}}</el-form-item>
          </el-col> -->
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  name: 'FileInfo',
  props: ['insideData', 'isAudit'],
  data () {
    return {
      form: {}
    }
  }
}
</script>
<style lang="less">
.flex-form .el-form-item__label {
  font-size: 14px;
  font-weight: 400;
  color: #666978;
}
</style>
<style scoped lang="less">
.title {
  border-bottom: 1px solid rgba(0, 0, 0,.1);
  margin-bottom: 15px;
  font-weight: 400;
  color: #33343B;
}
.flex-form {
  display: flex;
  justify-content:space-between;
  flex-wrap: wrap;
  margin-left: 10px;
  .label-key {
    white-space: nowrap;
  }
  .keywords{
    font-weight: 400;
    color: #595959;
    font-size: 12px;
    white-space: nowrap;
    border-radius: 2px;
    border: 1px solid #CFD1D8;
    padding: 0 2px;
    margin: 0 3px;
  }
}
</style>
